import commonMessages from '@/lang/messages/common';
import { EnumScreenName, EventProperties } from '@calm/evexia-analytics';
import { Typography } from '@rhg/libs/material';
import { WarningOutline } from '@rhg/libs/material/icons';
import { useIntl } from 'react-intl';
import { SheetDialog } from '../../sheet-dialog';
import { ageGenderMessages } from '../messages';

export interface UnderageDialogProps {
    trackScreen?: EnumScreenName;
    trackProps?: EventProperties;
    onClose: () => void;
    onLogout: () => void;
}

export function UnderageDialog({
    trackProps,
    trackScreen,
    onClose,
    onLogout,
}: UnderageDialogProps) {
    const { formatMessage } = useIntl();

    return (
        <SheetDialog
            onClose={onClose}
            trackDialog="UnderageNoAccessWarning"
            trackScreen={trackScreen}
            trackProps={trackProps}
            title={formatMessage(ageGenderMessages.notAvailableDialogTitle)}
            icon={<WarningOutline color="warning" />}
            content={
                <Typography variant="body1" textAlign="center">
                    {formatMessage(ageGenderMessages.notAvailableDialogCopy)}
                </Typography>
            }
            buttons={[
                {
                    trackButton: 'Cancel',
                    title: formatMessage(commonMessages['common.cancel']),
                    onClick: onClose,
                    variant: 'text',
                },
                {
                    trackButton: 'Logout',
                    title: formatMessage(commonMessages['common.logout']),
                    onClick: onLogout,
                },
            ]}
        />
    );
}
